module.exports = __webpack_public_path__ + "static/media/Socks_Dispensed.be1cbe1b.png";